import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import scaylorOrb from '../assets/images/ScaylorOrbB.svg';
import curvedWisp from '../assets/images/Background Curve Wisp.png'
import bluePinkGradient from '../assets/images/bluePnkGradient.svg'
import pinkRedGradient from '../assets/images/pinkRedGradient.svg'
const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token);

        // Check if they have a profile
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/users/me`, {
          headers: {
            'Authorization': `Bearer ${data.token}`,
            'Accept': 'application/json'
          }
        });

        if (userResponse.ok) {
          const userData = await userResponse.json();
          if (userData.name) {
            // They have a profile, check organization
            const orgResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/organization`, {
              headers: {
                'Authorization': `Bearer ${data.token}`,
                'Accept': 'application/json'
              }
            });

            if (orgResponse.ok) {
              const orgData = await orgResponse.json();
              if (orgData.organization) {
                navigate('/'); // They have everything, go to main page
              } else {
                navigate('/organization-setup'); // Need organization setup
              }
            } else {
              navigate('/organization-setup');
            }
          } else {
            navigate('/profile-setup'); // Need profile setup
          }
        } else {
          navigate('/profile-setup'); // Assume they need profile setup
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Login failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
      console.error('Login error:', err);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="h-screen flex items-start justify-center pt-24 overflow-hidden relative">
      {/* Background Wisp */}
      <div className="absolute bottom-0 left-0">
        <img 
          src={bluePinkGradient} 
          alt="Blue Pink Gradient" 
          className="w-[800px] opacity-500"
        />
      </div>

      {/*bluePinkGradient*/}
      <div className="absolute top-0 left-0">
        <img 
          src={curvedWisp} 
          alt="Background Wisp" 
          className="w-[300px] opacity-100"
        />
      </div>


       {/*pinkRedGradient*/}
       <div className="absolute top-0 right-0">
        <img 
          src={pinkRedGradient} 
          alt="Pink Red Gradient" 
          className="w-[700px] opacity-100"
        />
      </div>

      {/* Orb Background */}
      <div className="absolute inset-0 flex items-start justify-center pt-[4%]">
        <img 
          src={scaylorOrb} 
          alt="Scaylor Orb" 
          className="w-[800px] opacity-50"
        />
      </div>

      {/* Login Form - Glass Effect */}
      <div className="bg-white/10 backdrop-blur-md rounded-3xl p-44 py-[125px] w-[650px] shadow-lg z-10 relative mt-[5%]">
        <div className="flex flex-col items-center">
          <h1 className="text-7xl font-bold font-montserrat text-shadow-custom -mt-24 mb-6">SCAYLOR</h1>
        </div>
        
        <h2 className="text-2xl mb-6 font-Gilroy font-bold">Login</h2>
        
        {error && (
          <div className="mb-4 text-red-500 text-sm text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm mb-2 font-Gilroy font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="username@gmail.com"
              className="w-full px-3 py-2 border rounded-lg"
              required
            />
          </div>

          <div>
            <label className="block text-sm mb-2 font-Gilroy font-medium">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password"
              className="w-full px-3 py-2 border rounded-lg"
              required
            />
          </div>

          <div className="text-right">
            <a href="#forgot" className="text-sm text-gray-600 hover:underline">
              Forgot Password?
            </a>
          </div>

          <button
            type="submit"
            className="w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800 font-Gilroy font-bold"
          >
            Sign in
          </button>
        </form>

        <p className="mt-4 text-center text-sm text-gray-600">
          Don't have an account?{' '}
          <span
            onClick={() => navigate('/register')}
            className="text-blue-600 cursor-pointer hover:underline"
          >
            Register for free
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login; 